// extracted by mini-css-extract-plugin
export const container = "booking-module--container--sQLw5";
export const line = "booking-module--line--3VaOD";
export const footer = "booking-module--footer--NKM8V";